import React from "react";
import QuoteOverview from "../components/QuoteSection/QuoteOverview"
import QuoteInfo from "../components/QuoteSection/QuoteInfo";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import FAQ from "../components/FAQ";
import WhatsAppChat from "../components/WhatsAppChat";

const Quote = () => {
    return(
        <div>
            <Navbar />
            <QuoteOverview />
            <QuoteInfo/>
            <FAQ />
            <Footer />
            <WhatsAppChat/>
        </div>
    );

   
};

export default Quote;